import {
  InMemoryCache,
  ApolloClient,
  createHttpLink,
} from '@apollo/client/core';
import { createApolloProvider } from '@vue/apollo-option';

const cache = new InMemoryCache();

const httpLink = createHttpLink({
  uri: '/api/ad-data-aggregator/',
  credentials: false,
});

export const apolloClient = new ApolloClient({
  cache,
  link: httpLink,
  defaultOptions: {
    query: {
      fetchPolicy: 'no-cache',
    },
  },
});

export const provider = createApolloProvider({
  defaultClient: apolloClient,
});
